import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  private baseUrl = `${environment.Server_URL}/wallets`;

  constructor(private http: HttpClient) { }

  // ✅ تجيب كل المستخدمين اللي type = 9 مع الرصيد
  getAllUsersWithWallets(): Observable<any> {
    return this.http.get(`${this.baseUrl}/all`);
  }

  // ✅ تجيب رصيد مستخدم واحد عن طريق user_id
  getUserWallet(userId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${userId}`);
  }
  addWalletBalance(userId: number, amount: number, note?: string): Observable<any> {
    const body = { user_id: userId, amount, note };
    return this.http.post(`${this.baseUrl}/add-balance`, body);
  }
}
